import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

interface UpdateFacilityStay {
  uuid: string;
  data: any;
}

class FacilityStayService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getAllFacilityStay = (uuid: string, params: any) => {
    return this.axiosInstance.get(`${apiPath.GET_ALL_FACILITES_STAY}/${uuid}`, {
      params: { ...params },
    });
  };

  updateFacilityStay = (payload: UpdateFacilityStay) => {
    return this.axiosInstance.put(
      `${apiPath.GET_ALL_FACILITES_STAY}/${payload.uuid}`,
      payload.data
    );
  };

  createFacilityStay = (payload: UpdateFacilityStay) => {
    return this.axiosInstance.post(
      `${apiPath.GET_ALL_FACILITES_STAY}/${payload.uuid}`,
      payload.data
    );
  };

  getAllFacilities = (payload: any) => {
    return this.axiosInstance.get(`${apiPath?.GET_ALL_FACILITIES}`, {
      params: {
        ...payload,
      },
    });
  };
}

const facilityStayService = new FacilityStayService();

Object.freeze(facilityStayService);

export default facilityStayService;
